import type { RouteRecordRaw } from 'vue-router'

import { ROUTES } from '~/scopes/auth/route-names'

import { CHECKOUT_E_COMMERCE } from './route-names'

const routes: RouteRecordRaw[] = [
  {
    path: 'f2',
    name: CHECKOUT_E_COMMERCE.SELF,
    component: () => import('./layout/CheckoutFlow/CheckoutFlow.vue'),
    redirect: { name: CHECKOUT_E_COMMERCE.CART },
    meta: {
      owners: ['bot-squad-checkout-front'],
      layout: false,
    },
    children: [
      {
        name: CHECKOUT_E_COMMERCE.CART,
        path: 'cart',
        component: () => import('./pages/CartStep/CartStep.vue'),
        meta: {
          owners: ['bot-squad-checkout-front'],
          gtmStepId: 1,
        },
      },
      {
        path: 'addresses',
        name: CHECKOUT_E_COMMERCE.ADDRESSES,
        component: () => import('./pages/AddressesStep/AddressesStep.vue'),
        meta: {
          owners: ['bot-squad-checkout-front'],
          auth: {
            required: true,
            redirection: { name: ROUTES.AUTH.LOGIN },
          },
          gtmStepId: 4,
        },
      },
      {
        path: 'shipping/billing-address',
        name: CHECKOUT_E_COMMERCE.BILLING_ADDRESS,
        component: () =>
          import('./pages/BillingAddressStep/BillingAddressStep.vue'),
        meta: {
          owners: ['bot-squad-checkout-front'],
          auth: {
            required: true,
            redirection: { name: ROUTES.AUTH.LOGIN },
          },
          gtmStepId: 5,
        },
      },
      {
        path: 'shipping/shipping-address',
        name: CHECKOUT_E_COMMERCE.SHIPPING_ADDRESS,
        component: () =>
          import('./pages/ShippingAddressStep/ShippingAddressStep.vue'),
        meta: {
          owners: ['bot-squad-checkout-front'],
          auth: {
            required: true,
            redirection: { name: ROUTES.AUTH.LOGIN },
          },
          gtmStepId: 4,
        },
      },
      {
        path: 'shipping/confirmation-address',
        name: CHECKOUT_E_COMMERCE.ADDRESS_CONFIRMATION,
        component: () =>
          import('./pages/AddressConfirmationStep/AddressConfirmationStep.vue'),
        meta: {
          owners: ['bot-squad-checkout-front'],
          auth: {
            required: true,
            redirection: { name: ROUTES.AUTH.LOGIN },
          },
          gtmStepId: 4,
        },
      },
      {
        path: 'services/bouygues-telecom',
        name: CHECKOUT_E_COMMERCE.SERVICES.BOUYGUES.ROOT,
        redirect: { name: CHECKOUT_E_COMMERCE.SERVICES.BOUYGUES.SIGN_UP },
        meta: {
          owners: ['bot-squad-b2cservices-front'],
          auth: {
            required: true,
            redirection: { name: ROUTES.AUTH.LOGIN },
          },
        },
        children: [
          {
            path: 'sign-up',
            name: CHECKOUT_E_COMMERCE.SERVICES.BOUYGUES.SIGN_UP,
            component: () =>
              import('./pages/BouyguesSignUp/BouyguesSignUp.vue'),
            meta: {
              owners: ['bot-squad-b2cservices-front'],
            },
          },
          {
            path: 'phoneline-setup',
            name: CHECKOUT_E_COMMERCE.SERVICES.BOUYGUES.PHONELINE_SETUP,
            component: () =>
              import(
                './pages/BouyguesPhonelineSetup/BouyguesPhonelineSetup.vue'
              ),
            meta: {
              owners: ['bot-squad-b2cservices-front'],
            },
          },
          {
            path: 'not-eligible',
            name: CHECKOUT_E_COMMERCE.SERVICES.BOUYGUES.NOT_ELIGIBLE,
            component: () =>
              import(
                './pages/BouyguesPhonelineSetup/components/NotEligible/NotEligible.vue'
              ),
            meta: {
              owners: ['bot-squad-b2cservices-front'],
            },
          },
        ],
      },
      {
        path: 'payment',
        name: CHECKOUT_E_COMMERCE.PAYMENT,
        component: () => import('./pages/PaymentStep/PaymentStep.vue'),
        meta: {
          owners: ['bot-squad-checkout-front'],
          auth: {
            required: true,
            redirection: { name: ROUTES.AUTH.LOGIN },
          },
          payment: {
            contentSecurityPoliciesEnabled: true,
          },
          gtmStepId: 6,
        },
      },
    ],
  },
  {
    path: 'f2/payment-result/:paymentId?',
    name: CHECKOUT_E_COMMERCE.PAYMENT_RESULT,
    component: () => import('../../pages/Result/Result.vue'),
    meta: {
      owners: ['bot-squad-checkout-front'],
      auth: {
        required: true,
        redirection: { name: ROUTES.AUTH.LOGIN },
      },
    },
  },
  {
    path: 'f2/services/bouygues-telecom/auth',
    name: CHECKOUT_E_COMMERCE.SERVICES.BOUYGUES.AUTH,
    component: () =>
      import('./pages/BouyguesAuthentication/BouyguesAuthentication.vue'),
    meta: {
      layout: 'minimal',
      owners: ['bot-squad-b2cservices-front'],
    },
  },
]

export default routes
